import * as React from "react"
import {HTMLOptionLikeElement} from "../types";
import {CSSProperties, FormEventHandler} from "react";

export type CommonProps = {
	style?: CSSProperties
	name?: string
	enabled?: boolean
	children?: React.ReactNode
	invalid?: boolean
	onFocus?: FormEventHandler<HTMLSelectElement>
	onMouseOver?: FormEventHandler<HTMLSelectElement>
	onKeyDown?: FormEventHandler<HTMLSelectElement>
}

export type GenericProps = CommonProps & {
	onChange?: FormEventHandler<HTMLSelectElement>
	multiple?: boolean
	value?: string[]|string
}

export type SingleProps = CommonProps & {
	onChange: (a: string) => void
	value: string|undefined
}

export type MultiProps = CommonProps & {
	onChange?: (a: string[]) => void
	value?: string[]
	multiple: true
}

export type FlexiProps = CommonProps & {
	onChange?: (a: string[]) => void
} & ({ value: string[], multiple: boolean })

export type Props = SingleProps | MultiProps

const BoxImpl = (props: GenericProps) =>
	<select
		onChange={props.onChange}
		onFocus={props.onFocus}
		onMouseOver={props.onMouseOver}
		onKeyDown={props.onKeyDown}
		value={props.value}
		name={props.name}
		className="sbSelect"
		disabled={typeof props.enabled !== 'undefined' && !props.enabled}
		style={Object.assign({}, props.style, props.invalid ? {border: "solid red 2px"} : undefined)}
		multiple={props.multiple}
	>
		{props.children}
	</select>

export const SingleBox = (props: SingleProps) => <BoxImpl
	{...props}
	onChange={(event: React.FormEvent<HTMLSelectElement>) => {
		event.stopPropagation()
		if (props.onChange) {
			props.onChange(event.currentTarget.value)
		}
	}}
	multiple={false}
	/>

export const MultiBox = (props: MultiProps) => <BoxImpl
	{...props}
	onChange={(event: React.FormEvent<HTMLSelectElement>) => {
		event.stopPropagation()
		if (props.onChange) {
			const selectedOptions = Array.prototype.filter.call(
				event.currentTarget.options,
				(o:HTMLOptionLikeElement) => o.selected
			).map((o:HTMLOptionLikeElement) => o.value)
			props.onChange(selectedOptions)
		}
	}}
/>

export const FlexiBox = (props: FlexiProps) => {
	//despite the types, you can't send an array to a single select
	const value = props.multiple ? props.value : props.value[0]

	return <BoxImpl
		{...props}
		value={value}
		onChange={(event: React.FormEvent<HTMLSelectElement>) => {
			event.stopPropagation()
			if (props.onChange) {
				const selectedOptions = Array.prototype.filter.call(
					event.currentTarget.options,
					(o: HTMLOptionLikeElement) => o.selected
				).map((o: HTMLOptionLikeElement) => o.value)
				props.onChange(selectedOptions)
			}
		}}
	/>
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/select.tsx